import { buildApiUrl, getApiHeaders } from '../../config/api';

export interface VoipblSettings {
  id?: number;
  uuid?: string;
  enabled: boolean;
  lastSyncAt?: string | null;
  syncStatus?: string | null;
  autoUpdate?: boolean;
  ipCount?: number;
}

export interface VoipblSyncStats {
  previous: number;
  current: number;
  diff: number;
}

export const voipblApi = {
  getSettings: async (): Promise<{ data: VoipblSettings }> => {
    const response = await fetch(buildApiUrl('/api/admin/firewall/voipbl/settings'), {
      headers: await getApiHeaders(),
    });
    if (!response.ok) throw new Error('Failed to fetch VoIPBL settings');
    return { data: await response.json() };
  },
  updateSettings: async (data: Partial<VoipblSettings>): Promise<{ data: VoipblSettings }> => {
    const response = await fetch(buildApiUrl('/api/admin/firewall/voipbl/settings'), {
      method: 'PUT',
      headers: await getApiHeaders(),
      body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error('Failed to update VoIPBL settings');
    return { data: await response.json() };
  },
  triggerSync: async (): Promise<{ data: { success: boolean; output: string; stats?: VoipblSyncStats } }> => {
    const response = await fetch(buildApiUrl('/api/admin/firewall/voipbl/sync'), {
      method: 'POST',
      headers: await getApiHeaders(),
      body: JSON.stringify({}),
    });
    if (!response.ok) throw new Error('Failed to trigger VoIPBL sync');
    return { data: await response.json() };
  },
  searchIp: async (ip: string): Promise<{ data: { ip: string; isBlocked: boolean } }> => {
    const response = await fetch(buildApiUrl(`/api/admin/firewall/voipbl/search/${ip}`), {
      headers: await getApiHeaders(),
    });
    if (!response.ok) throw new Error('Failed to search IP');
    return { data: await response.json() };
  },
  getStats: async (): Promise<{ data: { packetsDropped: number; bytesDropped: number } }> => {
    const response = await fetch(buildApiUrl('/api/admin/firewall/voipbl/stats'), {
      headers: await getApiHeaders(),
    });
    if (!response.ok) throw new Error('Failed to fetch VoIPBL stats');
    return { data: await response.json() };
  },
};
